import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';
import { cn } from '@/utils/cn';
type GradientBackgroundProps = {
  position?: 'top' | 'bottom';
} & React.ComponentProps<'div'>;
export function GradientBackground(props) {
  const $ = _c(35);
  let className;
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      position: t0,
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
    $[3] = t0;
  } else {
    className = $[1];
    rest = $[2];
    t0 = $[3];
  }
  const position = t0 === undefined ? "top" : t0;
  const id = useId();
  const orangeId = `orange-${id}`;
  const redId = `red-${id}`;
  const blueId = `blue-${id}`;
  let t1;
  if ($[4] !== className) {
    t1 = cn("absolute left-1/2 -z-10 w-full max-w-300 -translate-x-1/2 data-[position=bottom]:bottom-0 data-[position=top]:top-0 data-[position=bottom]:[&>svg]:rotate-180", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = `url(#${orangeId})`;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ellipse cx="898.121" cy="7.207" fill="#FFB800" fillOpacity=".43" rx="284.881" ry="69.058" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2) {
    t4 = <g filter={t2}>{t3}</g>;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `url(#${redId})`;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ellipse cx="727.789" cy="48.819" fill="#E93F3F" fillOpacity=".43" rx="284.881" ry="131.671" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <g filter={t5}>{t6}</g>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = `url(#${blueId})`;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ellipse cx="504.666" cy="27.364" fill="#3F64E9" fillOpacity=".43" rx="284.881" ry="89.316" />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8) {
    t10 = <g filter={t8}>{t9}</g>;
    $[13] = t8;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== orangeId) {
    t11 = <Filter id={orangeId} width="1042.08" height="610.439" x="377.079" y="-298.012" />;
    $[15] = orangeId;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== redId) {
    t12 = <Filter id={redId} width="1042.08" height="735.665" x="206.747" y="-319.013" />;
    $[17] = redId;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== blueId) {
    t13 = <Filter id={blueId} width="1042.08" height="650.953" x="-16.376" y="-298.113" />;
    $[19] = blueId;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t11 || $[22] !== t12 || $[23] !== t13) {
    t14 = <defs>{t11}{t12}{t13}</defs>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t10 || $[26] !== t14 || $[27] !== t4 || $[28] !== t7) {
    t15 = <svg xmlns="http://www.w3.org/2000/svg" width="100%" fill="none" viewBox="0 0 1440 550" preserveAspectRatio="xMidYMid meet">{t4}{t7}{t10}{t14}</svg>;
    $[25] = t10;
    $[26] = t14;
    $[27] = t4;
    $[28] = t7;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== position || $[31] !== rest || $[32] !== t1 || $[33] !== t15) {
    t16 = <div data-position={position} className={t1} {...rest}>{t15}</div>;
    $[30] = position;
    $[31] = rest;
    $[32] = t1;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
}
type FilterProps = React.ComponentProps<'filter'>;
function Filter(props) {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <feFlood floodOpacity="0" result="BackgroundImageFix" />;
    t1 = <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />;
    t2 = <feGaussianBlur result="blur" stdDeviation="118.081" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" {...props}>{t0}{t1}{t2}</filter>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}